export const DUPLICATE_BOOKINGS_API_PATH = {
  LIST: "/v1/passenger-booking-list/",
};

export interface DuplicateBookingsQueryPayload {
  passenger_name: string;
  flight_number?: string;
  departure_date?: string;
}
